// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Sermorelin Refill 09.17.26" (7c7e5f52-2cce-49a3-b613-df034b3fe1a2). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiSermorelinRefillAnswerField } from './questions';

export const mdiSermorelinRefill: FormType<mdiSermorelinRefillAnswerField> = {
  name: 'Sermorelin Refill',
  validityLength: 25,
  questions: [
    'mdiSermorelinRefill_changesMedicalHistorySinceLast',
    'mdiSermorelinRefill_newAllergiesSinceLastPrescription',
    'mdiSermorelinRefill_diagnosedCancerSinceLastPrescription',
    'mdiSermorelinRefill_diagnosedLiverKidneyDiseaseSince',
    'mdiSermorelinRefill_erVisitsHospitalizationsSinceLast',
    'mdiSermorelinRefill_havingSideEffectsCurrentTreatment',
    'mdiSermorelinRefill_importantClickAttachedLinkReview',
    'mdiSermorelinRefill_messageDoctorLetThemKnow',
    'mdiSermorelinRefill_complete'
  ]
};
